import { render } from "./subpartA09.vue?vue&type=template&id=6a6fc149&scoped=true"
import script from "./subpartA09.vue?vue&type=script&lang=js"
export * from "./subpartA09.vue?vue&type=script&lang=js"

import "./subpartA09.vue?vue&type=style&index=0&id=6a6fc149&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a6fc149"]])

export default __exports__